import { ClickAwayListener } from "@mui/material";
import { type FunctionComponent, useMemo, useState } from "react";

import { useResponsive } from "shared/hooks";

import {
  ClickAwayListenerWrapper,
  Message,
  StyledIconInfo,
  StyledTooltip,
  TriggerButton,
} from "./styles";

type Props = {
  className?: string;
  message: string;
};

export const SearchInfoTooltip: FunctionComponent<Props> = ({ className, message }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isHoverDevice = useResponsive("(hover: hover)", false);

  const triggerHandlers = useMemo(
    () =>
      isHoverDevice
        ? { onMouseEnter: () => setIsOpen(true), onMouseLeave: () => setIsOpen(false) }
        : { onClick: () => setIsOpen(current => !current) },
    [isHoverDevice],
  );

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <ClickAwayListenerWrapper className={className}>
        <StyledTooltip
          arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={isOpen}
          placement="bottom-start"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "preventOverflow",
                  options: { padding: 16 },
                },
              ],
            },
          }}
          title={<Message>{message}</Message>}
        >
          <TriggerButton type="button" {...triggerHandlers}>
            <StyledIconInfo />
          </TriggerButton>
        </StyledTooltip>
      </ClickAwayListenerWrapper>
    </ClickAwayListener>
  );
};

SearchInfoTooltip.displayName = "SearchInfoTooltip";
